export const ERROR_CODES = ({
    email_used: {
        code: 3508,
        label: 'pages.application.detail.dialogs.editClient.feedback.4'
    },
    no_zeus_code_provided: {
        code: 3906,
        label: 'pages.application.detail.zeus_error'
    }
  })